import { ColumnPrimitive, CsvImportColumn } from '../../../lib/csv';

type CsvPackageType = 'BASE' | 'PKG' | 'ALC';
type CsvDeviceModelSystemType = 'MR' | 'MF';

export interface OperatorImport {
  operatorId: number;
  operatorName: string;
  operatorCode: string;
  timeZone: string;
  mediaroom: boolean;
  mediaFirst: boolean;
  defaultCreditLimit: number | null;
  creditResetDay: number | null;
  enhancedData: boolean | null;
  gratisAccounts: number | null;
  appKeyUrl1: string | null;
  appKeyUrl2: string | null;
  appKeyUrl3: string | null;
  appKeyUrl4: string | null;
  useScreensaver: boolean | null;
  subscribedChannelView: boolean | null;
  branch: string;
  mediaFirstStreams: number | null;
  tenantId: string | null;
  subTenantId: string | null;
  usesTgOAuth: boolean | null;
  mediaFirstRecorderId: string | null;
}

export interface BuildCsvImportColumn<T> {
  name: keyof T;
  note?: string;
  options?: string[];
  type: ColumnPrimitive;
}

export interface PackageImport {
  name: string;
  description: string;
  type: CsvPackageType;
}

export interface DeviceModelImport {
  name: string;
  canDVR: boolean;
  clientVersion: string;
  system: CsvDeviceModelSystemType;
}

export interface FipsCodeImport {
  code: string;
  countyName: string;
}

export interface TransportImport {
  name: string;
  ingressHD: number;
  ingressSD: number;
  wanHD: number;
  wanSD: number;
}

export const buildCsvColumns = <T>(
  columns: BuildCsvImportColumn<T>[]
): CsvImportColumn[] => columns as CsvImportColumn[];

export const mapAccountSettings = (
  data: CreateOperatorAccountSettings[]
): CreateOperatorAccountSettings[] => [data[0]];

export const mapCsvDeviceModels = (
  data: DeviceModelImport[]
): CreateDeviceModel[] =>
  data.map((model) => ({
    active: true,
    clientVersion: model.clientVersion,
    name: model.name,
    canDVR: model.canDVR,
    system: model.system,
  }));

export const mapFipsCodes = (data: FipsCodeImport[]): CreateFipsCode[] =>
  data.map((fips) => ({
    active: true,
    code: fips.code,
    county: fips.countyName,
  }));

export const mapMediaRoomSettings = (
  data: CreateOperatorMediaRoomSettings[]
): CreateOperatorMediaRoomSettings[] => [data[0]];

export const mapMediaFirstSettings = (
  data: CreateOperatorMediaFirstSettings[]
): CreateOperatorMediaFirstSettings[] => [data[0]];

export const mapCsvPackages = (
  data: PackageImport[]
): CreateOperatorPackage[] =>
  data.map((pkg) => ({
    active: true,
    name: pkg.name,
    description: pkg.description,
    type: formatPackageType(pkg.type),
  }));

export const mapTransports = (data: TransportImport[]): CreateTransportType[] =>
  data.map((transport) => ({
    active: true,
    name: transport.name,
    ingressHD: transport.ingressHD,
    ingressSD: transport.ingressSD,
    wanHD: transport.wanHD,
    wanSD: transport.wanSD,
  }));

const formatPackageType = (type?: string): PackageType | null => {
  switch ((type ?? '').toLowerCase()) {
    case 'base':
      return 'base';
    case 'alc':
      return 'alaCarte';
    case 'pkg':
      return 'addons';
    default:
      return null;
  }
};
